import { render } from "./widget-notebook-core.vue?vue&type=template&id=54f22f02"
import script from "./widget-notebook-core.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-notebook-core.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/widgets/widget-notebook-core.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54f22f02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54f22f02', __exports__)) {
    api.reload('54f22f02', __exports__)
  }
  
  module.hot.accept("./widget-notebook-core.vue?vue&type=template&id=54f22f02", () => {
    api.rerender('54f22f02', render)
  })

}


export default __exports__